/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-plusplus */
import React, { useEffect, useRef, useState } from 'react';
import { NumericFormat } from 'react-number-format';
import { getMonth, getYear, subDays, subMonths, getDate } from 'date-fns';
import { getCount } from './CountingApi';

const today = new Date();
const yesterday = subDays(today, 1);
const lastMonth = subMonths(today, 1);
const DEFAULT_COUNTS = [
  {
    year: getYear(today),
    month: getMonth(today) + 1,
    day: getDate(today),
    title: 'Truy cập hôm nay',
    value: '...',
    loading: true,
  },
  {
    year: getYear(yesterday),
    month: getMonth(yesterday) + 1,
    day: getDate(yesterday),
    title: 'Truy cập hôm qua',
    value: '...',
    loading: true,
  },
  {
    year: getYear(today),
    month: getMonth(today) + 1,
    day: 0,
    title: 'Truy cập tháng này',
    value: '...',
    loading: true,
  },
  {
    year: getYear(lastMonth),
    month: getMonth(lastMonth) + 1,
    day: 0,
    title: 'Truy cập tháng trước',
    value: '-',
    loading: true,
  },
  {
    year: getYear(today),
    month: 0,
    day: 0,
    title: 'Truy cập năm nay',
    value: '...',
    loading: true,
  },
  {
    year: 0,
    month: 0,
    day: 0,
    title: 'Tổng truy cập',
    value: '...',
    loading: true,
  },
];

function Counting() {
  const countsRef = useRef(DEFAULT_COUNTS);
  const [counts, setCounts] = useState(DEFAULT_COUNTS);

  useEffect(() => {
    countsRef.current.forEach(({ year, month, day }, index) => {
      getCount({ year, month, day }).then(({ Message }) => {
        countsRef.current[index] = {
          ...countsRef.current[index],
          value: Message,
          loading: false,
        };
        setCounts([...countsRef.current]);
      });
    });
  }, []);

  return (
    <div className="module  clients-say">
      <h3 className="modtitle">THỐNG KÊ</h3>
      {counts.map(({ title, value }) => (
        <p>
          <i className="fa fa-bar-chart out-line" />
          <span className="out-line truy-cap">{title}:</span>
          <a className="title ml-3" href="#" title="Online">
            <NumericFormat
              value={value}
              displayType="text"
              thousandSeparator=","
            />
          </a>
        </p>
      ))}
    </div>
  );
}

export default Counting;
